import { decisionItem } from './decisionItem';
export const decisionList = node => {
  const result = [];
  node.forEach(item => {
    result.push(decisionItem(item));
  });
  return result.join('\n');
};